const container = $('.container');

$(container).on('click', '.idea-how-to-add-lesson', function () {
    if (!$(this).siblings().hasClass("show-idea-content")) {
        $(this).siblings().addClass("show-idea-content");
    } else {
        $(this).siblings().removeClass("show-idea-content");
    }
});